<template>
    <BlockContainer
        :id="'page-intro-' + slugify(data.heading)"
        :background-color="data.backgroundColor"
        :bottom-angle="data.bottomAngle"
        :angle-background-color="
            data.nextBackgroundColor ? data.nextBackgroundColor : null
        "
    >
        <div
            class="m-auto justify-center md:flex md:w-10/12"
            :class="data.textColor ? 'text-' + data.textColor : null"
        >
            <div
                class="flex flex-col items-center gap-x-8 pt-16 md:pt-24 lg:gap-y-4"
                :class="{ 'pb-16 md:pb-24': data.paddingBottom === 'normal' }"
            >
                <h1
                    class="border-grind pb-4 text-center md:border-b-0 md:pb-0 2xl:min-w-fit"
                >
                    {{ data.heading }}
                </h1>

                <div class="flex w-full items-center pt-5 text-center">
                    <WysiwygContent
                        :content="data.content"
                        class="w-full text-balance"
                    />
                </div>

                <ButtonContainer v-if="data.buttons.length" class="pt-8">
                    <Button
                        v-for="button in data.buttons"
                        :key="button.label"
                        :button="button"
                    />
                </ButtonContainer>
            </div>
        </div>
    </BlockContainer>
</template>

<script setup lang="ts">
import type { PageIntroType } from '#shared/types/PageIntroType';
import BlockContainer from '~/components/BlockContainer.vue';
import ButtonContainer from '~/components/ButtonContainer.vue';
import Button from '~/components/page-building/components/Button.vue';

defineProps<{
    data: PageIntroType;
}>();
</script>
